import styled from 'styled-components'
import media from '../../../styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 3rem 0;

  ${media.md`
    padding : 0 20px;
  `}
`
export const Img = styled.img`
  max-width: 140px;
  margin-bottom: 1rem;
`

export const Title = styled.h2`
  font-size: 1.8rem;
  color: #007bff;
  line-height: 1.1;
  margin-bottom: 1rem;
  text-align: center;
`

export const Detail = styled.p`
  margin-top: 0;
  margin-bottom: 1rem;
  color: #7a7878;
  font-size: 1rem;
  text-align: center;
`
